module.exports = __webpack_public_path__ + "img/caret-up.f63f868a.svg";